import { DocumentProcessingJob } from '@/models/DocumentProcessingJob';
import { Issue } from '@/models/Issue';
import { apiClient } from '@/services/api';
import { logger } from '@/utils/logger/loggerInstance';

export const getIssuesForProperty = async (propertyId: string) => {
  const url = `/properties/${propertyId}/issues`;

  logger.debug(`GET ${url}`);
  const response = await apiClient.get<Issue[]>(url);

  return response.data;
};

export const requestRFQForIssue = async (issueId: string) => {
  const url = `/issues/${issueId}/request-rfq`;

  logger.debug(`POST ${url}`);
  const response = await apiClient.post<DocumentProcessingJob>(url, {});

  return response.data;
};

export const requestIssueKnowledgeBaseForIssue = async (issueId: string) => {
  const url = `/issues/${issueId}/request-knowledge-base`;

  logger.debug(`POST ${url}`);
  const response = await apiClient.post<DocumentProcessingJob>(url, {});

  return response.data;
};

export const resolveIssue = async (issueId: string) => {
  const url = `/issues/${issueId}/resolve`;

  logger.debug(`POST ${url}`);
  const response = await apiClient.post<Issue>(url, {});

  return response.data;
};

export const unresolveIssue = async (issueId: string) => {
  const url = `/issues/${issueId}/unresolve`;

  logger.debug(`POST ${url}`);
  const response = await apiClient.post<Issue>(url, {});

  return response.data;
};
